import { getCardVerboseFromFallWinterDeckById } from '@lc/card/FallWinter';
import { getCardVerboseFromSpringSummerDeckById } from '@lc/card/SpringSummer';
import { SummitVerbose } from '@lc/card/verbose/SummitVerbose';
import { summitResolution } from '@lc/const/turnTypes';
import { GameState } from '@lc/interface/gameState/types';
import { getPlayerStateWithId } from '@lc/lib/player_helper';

export default class CardController {
	activateCardTrigger(cardId: number, _gameState: GameState) {
		const currCard = this.getCurrCard(cardId) as any;

		currCard.trigger();
	}

	discardEquipment(playerData: any, gameState: GameState) {
		const { playerId, cardId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);

		const index = pState.equipment.indexOf(cardId);
		if (index === -1) return false;

		pState.equipment.splice(index, 1);
		const currCard = this.getCurrCard(cardId) as any;
		currCard.discardAction(playerData, gameState);

		return true;
	}

	getCurrCard(cardId: number) {
		if (cardId - 100 >= 0) {
			return getCardVerboseFromFallWinterDeckById(cardId - 100);
		}

		return getCardVerboseFromSpringSummerDeckById(cardId);
	}

	playEquipmentCardById(playerData: any, gameState: GameState) {
		const {
			playerId,
			cardId,
			// discardCardId,
			// paymentObject
		} = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);

		const index = pState.equipment.indexOf(cardId);
		if (index === -1) return false;
		const currCard = this.getCurrCard(cardId) as any;

		// TODO MODIFIERS ARE DETERMINED BY CARD'S FUNCTION, ALWAYS
		if (currCard.hasDiscardAction) {
			pState.equipment.splice(index, 1);
			// currCard.discardAction(playerData, gameState);
			return true;
		} else if (currCard.hasRepeatableAction) {
			if (pState.modifiers.includes(currCard.modifier)) {
				return false;
			}
			currCard.persistentAction(playerData, gameState);
			// pState.modifiers.push(currCard.modifier);
			return true;
		}

		return false;
	}

	playSummitCardById(playerData: any, gameState: GameState) {
		const { playerId, cardId, paymentObject, gameId } = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);

		const index = pState.summitCards.indexOf(cardId);
		if (index === -1) return false;
		const currCard = SummitVerbose[cardId];

		// this is a hack, but summit cards should be designated by turn & winter.
		// Right now we just prevent play if on frontend
		pState.summitCards.splice(index, 1);
		currCard.action(playerData, gameState);
		return true;
	}

	playSummitWinterCardById(playerData: any, gameState: GameState) {
		const {
			playerId,
			cardId,
			// paymentObject,
			// gameId
		} = playerData;
		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);

		const index = pState.summitCards.indexOf(cardId);
		if (index === -1) return false;
		const currCard = SummitVerbose[cardId];

		// this is a hack, but summit cards should be
		pState.summitCards.splice(index, 1);
		currCard.action(playerData, gameState);
		return true;
	}

	// recieve card ID request from play
	// check they have card
	// check they can play it
	// play card, update state
	playCardById(playerData: any, gameState: GameState) {
		const { playerId, cardId, decisionId } = playerData;

		const pState = getPlayerStateWithId(
			gameState.playerStateArray,
			playerId
		);

		console.log('unshifting card with id ' + cardId);

		if (!pState.seasonalCards.includes(cardId)) {
			// check if card with ID is on player array, otherwise ignore
			return;
		}

		// TODO if card Id has been played (is in discard pile) return here
		const currCard = this.getCurrCard(cardId) as any;
		console.log('currCard');
		console.log(currCard);

		if (currCard.type === 'Award') {
			console.log('unshifting card with id ' + cardId);
			pState.activeContractsAndAwards.unshift(cardId); // we iterate through awards and contracts from last to first
			this.removeCard(pState, cardId);
			return true;
		} else if (currCard.type === 'Contract') {
			currCard.actionFund(playerData, gameState);
			// CONTRACTS WILL ATTACH MODIFIERS TO CLIENTS ON .actionFund()
			// if (currCard.modifier !== ``) {
			//     pState.modifiers.push(currCard.modifier);
			// }
			console.log('playing contract ya heard');
			pState.activeContractsAndAwards.unshift(cardId);
			this.removeCard(pState, cardId);
			return true;
		} else if (currCard.type === 'Equipment') {
			currCard.initAction(playerData, gameState);

			// test if card has init, discard or persistent action
			// discard means you need to add modifier
			pState.equipment.unshift(cardId);
			this.removeCard(pState, cardId);
			if (currCard.hasDiscardAction) {
				pState.modifiers.push(currCard.modifier);
			}
			return true;
		} else {
			console.log('you shouldnt be here');
			const cardPlayable = currCard.action(playerData, gameState);

			if (cardPlayable) {
				this.removeCard(pState, cardId);
				gameState.discardPile.push(cardId);
				return true;
			}
		}

		return false;
	}

	removeCard(pState: any, cardId: number) {
		const cIndex = pState.seasonalCards.indexOf(cardId);
		pState.seasonalCards.splice(cIndex, 1);
	}

	/**
	 * Takes in a card id along with a player's choice (decisionId), chooses from array of actions on card
	 * removes card from active array and puts contract or award in completed, failed, discard etc.
	 * @param playerData
	 * @param gameState
	 * @returns whether decision we advances our timeline pr returns control to player
	 */
	async resolvePlayerDecision(
		playerData: any,
		gameState: GameState,
		ticker: string[]
	) {
		const { playerId } = playerData;

		console.log('RESOLVE PLAYER DECISION');
		console.log('PLAYER DATA');
		console.log(playerData);

		ticker.unshift(`Player ${playerId} has `);

		const cardId = gameState.decisionCardId;
		const currCard = this.getCurrCard(cardId) as any;

		console.log('currCard');
		console.log(currCard);

		let isAdvanceTimeline = false;

		if (currCard.type === 'Award') {
			const pState = gameState.playerStateArray[playerId];

			isAdvanceTimeline = currCard.action(playerData, gameState);

			// AWARDS CAN BE PART OF ANY PLAYER'S ACTIVE PILE, SO WE MUST TRY TO DELETE IT FROM EACH
			const players = gameState.playerStateArray;
			for (let i = 0; i < players.length; i++) {
				const aIndex =
					players[i].activeContractsAndAwards.indexOf(cardId);
				if (cardId > -1) {
					players[i].activeContractsAndAwards.splice(aIndex, 1);
				}
			}

			pState.completedAwards.push(cardId);
			pState.completedContractsAndAwards.push(cardId);

			gameState.turnType = summitResolution;
			gameState.decisionCardId = -1;
		}

		return isAdvanceTimeline;
	}
}

export const controller_card = new CardController();
